const g = require('globals')
const $ = require('lib/jquery')
const Backbone = require('lib/backbone')
const RelatedList = require('module/user/related_list')
const RelatedModel = require('module/user/related_model')
const Raven = require('lib/raven')
const log = require('log').create('domain', 'dns') // eslint-disable-line

const godaddy_consent_url = (
    'https://dcc.godaddy.com/manage/v2/domainTemplates/providers/about.me/services/website/apply?domain='
)

const support_urls = {
    'godaddy.com': 'https://support.about.me/article/168-connecting-your-godaddy-domain',
    'enom.com': 'https://support.about.me/article/167-connecting-your-enom-domain',
    'namecheap.com': 'https://support.about.me/article/169-connecting-your-namecheap-domain',
    'hover.com': 'https://support.about.me/article/170-connecting-your-hover-domain',
    'bluehost.com': 'https://support.about.me/article/171-connecting-your-bluehost-domain',
    'networksolutions.com': 'https://support.about.me/article/172-connecting-your-network-solutions-domain',
    'domains.google': 'https://support.about.me/article/173-connecting-your-google-domain',
    'dreamhost.com': 'https://support.about.me/article/174-connecting-your-dreamhost-domain',
    'domain.com': 'https://support.about.me/article/175-connecting-your-domain-com-domain',
    '1and1.com': 'https://support.about.me/article/176-connecting-your-1-1-domain',
}
const default_support_url = 'https://support.about.me/article/129-using-your-own-domain'

const DnsModel = RelatedModel.extend({

    id: 'dns',

    defaults: {
        records: [],
    },

    relations: [
        {
            key: 'records',
            type: Backbone.Many,
            collectionType: RelatedList.extend({
                id: 'records',
                model: RelatedModel,
                // sort A records before CNAME records (relies on alphabetical sort)
                comparator: 'record_type',
            }),
        },
    ],

    // eslint-disable-next-line object-shorthand
    constructor: function constructor(attrs, options = {}) {
        options.parse = true
        RelatedModel.apply(this, [attrs, options])
    },

    initialize() {
        this.domain = this.getDomain()
    },

    validate(attrs) {
        try {
            const error = this.findFirstError(attrs)
            return error
        } catch (err) {
            Raven.captureMessage('DNS validate failed', {
                extra: {
                    attrs,
                    err,
                },
            })
        }
    },

    findFirstError(attrs) {
        const errors = (
            // convert to JSON
            attrs.records.toJSON()

            // check all records for primary domains
            // only check A records for subdomains
            .filter(record => {
                if (this.domain && this.domain.isSubdomain()) {
                    return record.record_type === 'a'
                }
                return true
            })

            // only include records with errors
            .filter(record => !! record.error)

            // map to just the error string
            .map(record => record.error)
        )

        // return the first error string
        // returns undefined if there are no errors
        return errors[0]
    },

    // keeping this helper method around in case the above doesn't shed light on the problem
    // getRecordsArray(records) {
    //     if (! records) return []
    //     if (Array.isArray(records)) return records
    //     if (records.toJSON) return records.toJSON()
    //     return []
    // },

    calculated_values: {
        registrar_consent_url() {
            switch (this.get('registrar')) {
                case 'godaddy.com':
                    return this.get('godaddy_consent_url')
                default:
                    return ''
            }
        },
        godaddy_consent_url() {
            const domain = this.domain.get('domain')
            if (! domain) return ''
            return `${godaddy_consent_url}${domain}`
        },
        support_url() {
            const registrar = this.get('registrar')
            return support_urls[registrar] || default_support_url
        },
    },

    getDomain() {
        return this.parents && this.parents[0]
    },

    fetch(options) {
        // if we don't have an active request, make one
        if (! this.fetch_dns_request) {

            this.fetch_dns_request = $.ajax({
                url: `${g.NODE_API}/validate_domain_dns`,
                type: 'GET',
                data: {
                    domain: this.domain.get('domain'),
                },
            })
            .done((attrs) => {
                // set attributes from the response
                this.set(this.parse(attrs), options)
            })
            .always(() => {
                // remove cached request object
                delete this.fetch_dns_request
            })
        }

        return this.fetch_dns_request
    },

    parse(attrs) {
        // ignore old-a-record error for now
        // https://github.com/aboutdotme/main/issues/6229
        if (attrs && Array.isArray(attrs.records)) {
            attrs.records.forEach(record => {
                if (record.error === 'old-a-record') {
                    delete record.error
                }
            })
        }
        return attrs
    },

})

module.exports = DnsModel
